
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const mf25SummingMixer: IProductData = {
  id: "purple-audio-summing-mixer",
  name: "Purple Audio MFTwenty5 Summing Mixer",
  description: "1U Summing mixer",
  specialOrder: true,
  images: ["/img/purpleaudio_summing_mixer_front.png", "/img/purpleaudio_summing_mixer_back.png"],
  details: [{
    label: "Description",
    markdown: `
The MFTWENTY5 is a rack mountable summing mixer,  designed for the 500 series.  A dual input 10×2 with stereo solo buss, and mono Aux buss.  
The MFTWENTY5 brings new use and value to your 500 series racks and modules. This mixer is made of discrete parts, and allows for multiple configurations including dual input, mono, and stereo stem mixing. The MFTWENTY5 uses fifty five discrete op amps and has a transformer balanced output on the  stereo mix. Use the MFTWENTY5 for your console, sidecar, or something bigger by taking advantage of the ability to cascade multiple units to create larger platforms.   
The MFTWENTY5 1-RU summing mixer can be used in conjunction with the Purple Audio Meter Bridge and Fader Pack products to create a fully modular console, or standalone with your current gear.  

The MFTwenty5 1-RU summing mixer is a dual input 20×2 mixer. Each channel is assignable mono or stereo.  
In mono mode the bottom concentric knob is pan, in stereo it is balance.  
If the unit is set up without the optional fader pack, the top knob is used as the fader.  
When the unit is configured with the fader pack connected, the top knob controls a mono aux send.  
Each aux send on the MFTWENTY5 can be assigned to pre or post fader, the push switch on that knob acts as the aux mute.  
As all the inputs are multed and show up on DB-25, you are able to plug your converter output or any combination of outboard or 500 modules directly in as inputs to the MFTWENTY5.  
Giving you a 20 x 2 stem mixer or a 10 x 2 mono input mixer.  

The MFTwenty5 is a perfect way to add more flexibility to a large format console.   
Add ten stereo returns  or ten more mono channels, use it to sum 16 busses to a grand master.   
Use it to sum multiple compressors or equalizers in mono or stereo to create your own unique system.  
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://purpleaudio.com/products/mf-twenty-25/" target="_blank">https://purpleaudio.com/products/mf-twenty-25/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.MASTERING],
    manufacturer: BRAND.PURPLE_AUDIO,
  },
  videos: []
}